export default "__VITE_ASSET__23808497__"